"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addIdsToLoadQueue = void 0;
const addIdsToLoadQueue = (newIds, highPriority = false) => (oldIds) => {
    if (!newIds.length) {
        return oldIds;
    }
    const priorityList = [(oldIds !== null && oldIds !== void 0 ? oldIds : []), newIds];
    if (highPriority) {
        priorityList.reverse();
    }
    const [firstList, secondList] = priorityList;
    const uniqueIds = Array.from(new Set([...firstList, ...secondList]));
    // oldIds is returned to keep the reference the same when the list has not changed
    if (uniqueIds.length === (oldIds !== null && oldIds !== void 0 ? oldIds : []).length) {
        return oldIds;
    }
    return uniqueIds;
};
exports.addIdsToLoadQueue = addIdsToLoadQueue;
